import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import './i18n';

// Bascule maintenance : si REACT_APP_MAINTENANCE=true, on n'initialise pas
// l'application et on redirige vers la page statique public/maintenance.html.
// L'URL d'origine est transmise via ?from= pour que le bouton « Réessayer »
// ramène l'utilisateur au bon écran une fois la maintenance levée.
if (process.env.REACT_APP_MAINTENANCE === "true") {
  const from = encodeURIComponent(window.location.pathname + window.location.search);
  window.location.replace(`/maintenance.html?from=${from}`);
} else {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(<App />);

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}
